import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveriesListComponent } from './deliveries-list/deliveries-list.component';
import { TransportsListComponent } from './transports-list/transports-list.component';
import { DeliveryComponent } from './delivery/delivery.component';
import { TransportComponent } from './transport/transport.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { UiModule } from '@icc/ui';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '@icc/shared';
import { B2BSharedModule } from 'libs/b2b/shared/src/lib/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DeliverySortOrderIconComponent } from './sort-order-icon/sort-order-icon.component';
import { B2bSalesDocumentModule } from '@icc/b2b/sales-document';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { TransportStatusComponent } from './transport-status/transport-status.component';
import { TransportFiltersComponent } from './transport-filters/transport-filters.component';

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        UiModule,
        CdkTreeModule,
        HttpClientModule,
        NgxPaginationModule,
        SharedModule,
        B2BSharedModule,
        TranslateModule,
        B2bSalesDocumentModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
    ],
    declarations: [
        DeliveriesListComponent,
        TransportsListComponent,
        DeliveryComponent,
        TransportComponent,
        DeliverySortOrderIconComponent,
        TransportStatusComponent,
        TransportFiltersComponent,
    ],
    exports: [
        DeliveriesListComponent,
        TransportsListComponent,
        DeliveryComponent,
        TransportComponent,
    ],
})
export class B2bTransportModule {}
